import { render } from "./DatabaseIndexesPage.vue?vue&type=template&id=31d13719&scoped=true&ts=true"
import script from "./DatabaseIndexesPage.vue?vue&type=script&lang=ts"
export * from "./DatabaseIndexesPage.vue?vue&type=script&lang=ts"

import "./DatabaseIndexesPage.vue?vue&type=style&index=0&id=31d13719&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d13719"]])

export default __exports__